<template>
  <header class="pageheader-container">
    <nav class="pageheader-wrap">
      <!-- PC -->
      <ul class="h_100per pageheader">
        <li class="h_100per pageheader-leftwrap">
          <img
            @click="clickAside"
            class="common-hambugerbar-img cursor"
            src="/media/images/icon/hambugerbar-icon.png"
            alt="hambugerbar-img.png"
          />
          <img @click="onClickLogo" class="common-logo-img" src="/media/images/logo/aplayz-logo-red.png" alt="logo" />
        </li>
        <li class="h_100per pageheader-middle">
          <InputBox
            v-if="isshowaiinputbox"
            :border="'border-radius-50'"
            :status="'error'"
            :disabled="true"
            :disabledcolor="'disabledwhite'"
            :placeholder="'AI와 채팅하고 음악을 추천 받아보세요.'"
            :size="'md'"
            @click-event="clickInput"
          >
            <template #aftercontents>
              <img src="/media/images/icon/send_abled_icon.png" alt="send_abled_icon.png" class="abled-icon" />
            </template>
          </InputBox>
        </li>
        <li class="h_100per pageheader-rightwrap">
          <activityButton
            @click="onClickAlarm"
            :isActive="isActive"
            class="activity-btn"
            :aria-label="isActive ? '읽지 않은 알림이 있습니다' : '알림'"
            role="button"
            tabindex="0"
          />
        </li>
      </ul>
      <!-- MOBILE -->
      <ul class="mo-pageheader">
        <!-- Left Area -->
        <li class="left-area">
          <slot name="left-area"></slot>
        </li>
        <!-- Center Area -->
        <li class="center-area">
          <span class="mo-page-title">
            <slot name="center-area"></slot>
          </span>
        </li>
        <!-- Right Area -->
        <li class="right-area">
          <slot name="right-area"></slot>
        </li>
      </ul>
    </nav>
  </header>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import ActivityButton from '../common/ActivityButton.vue';
import InputBox from '../InputBox/InputBox.vue';
export default {
  props: {
    isshowaiinputbox: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['click-aside'],
  components: {
    InputBox,
    ActivityButton
  },
  computed: {
    ...mapState('notification', {
      isActive: state =>
        state.items.some(item => {
          // Common Notice 제외, 일반 사용자 알림만 체크
          const isCommonNotice = item.commonNoticeContents || item.commonNoticeId || item.noticeCategory === 'Event';
          return !isCommonNotice && item.noticeReadYn === 'N';
        })
    })
  },
  methods: {
    ...mapActions('notification', { loadList: 'load' }),
    loadNotificationList() {
      const userId = this.$cookies.get('userId');
      if (userId) {
        this.loadList({ userId });
      }
    },
    clickAside() {
      this.$emit('click-aside');
    },
    clickInput() {
      this.$gatag.event('web_ai_chat_page_input_button'); // ai 채팅 페이지 이동
      this.$router.push({ path: '/aichannel' });
    },
    onClickAlarm() {
      this.$gatag.event('web_setting_page_notification_setting'); // 알림 설정
      this.$router.push({ path: '/notice/notice0' });
    },
    onClickLogo() {
      this.$router.push({ path: '/main' });
    }
  },
  created() {
    this.loadNotificationList();
  },
  watch: {
    $route() {
      // 라우트 변경 시 알림 목록 새로고침
      this.loadNotificationList();
    }
  }
};
</script>
<style scoped src="@/assets/css/pageheader/pageheader.css"></style>
